(function () {
	function applyCssVars(css) {
		if (!css) return;
		var el = document.getElementById("wd-theme-vars");
		if (!el) {
			el = document.createElement("style");
			el.id = "wd-theme-vars";
			document.head.appendChild(el);
		}
		el.textContent = css;
	}

	function applyBranding(b) {
		if (!b) return;
		var logo = b.logo || "/assets/wajbat_desk/images/logo.png";
		var name = b.company_name || "وجبة الطالب";

		document.querySelectorAll(".page-card-head .app-logo").forEach(function (img) {
			img.setAttribute("src", logo);
			img.setAttribute("alt", name);
		});

		document.querySelectorAll(".wd-login-brand").forEach(function (n) {
			n.remove();
		});

		if (b.favicon) {
			document
				.querySelectorAll('link[rel="shortcut icon"], link[rel="icon"]')
				.forEach(function (n) {
					n.setAttribute("href", b.favicon);
				});
		}
		if (name) document.title = name;
	}

	function load() {
		fetch("/api/method/wajbat_desk.api.get_theme_css")
			.then(function (r) {
				return r.json();
			})
			.then(function (r) {
				applyCssVars(r.message);
			})
			.catch(function () {});

		fetch("/api/method/wajbat_desk.api.get_branding")
			.then(function (r) {
				return r.json();
			})
			.then(function (r) {
				applyBranding(r.message);
			})
			.catch(function () {});
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", load);
	} else {
		load();
	}
})();
